import { PortableText, PortableTextReactComponents } from "@portabletext/react"
import { SanityFeatSnippetPortableText } from "./FeaturedSnippetModule.d"
import { Link } from "../../atoms/Link"
import tw from "twin.macro"
import React, { useContext, useMemo } from "react"
import { DisclaimersContext } from "../../../contexts/Disclaimers"
import { parseDisclaimerBlocks } from "../../../helpers"
import { toggleDisclaimersModal } from "../../../contexts/Disclaimers/actions"

const FeaturedSnippetPortableText: React.FC<SanityFeatSnippetPortableText> = ({
  portableTextEditor,
}) => {
  let blocks = portableTextEditor
  const [state, dispatch] = useContext(DisclaimersContext)
  if (blocks && !Array.isArray(blocks)) {
    blocks = [blocks]
  }

  const portableTextComponents = useMemo<
    Partial<PortableTextReactComponents>
  >(() => {
    return {
      list: {
        bullet: ({ children }) => <ul>{children}</ul>,
        number: ({ children }) => <ol>{children}</ol>,
      },
      listItem: {
        bullet: ({ children }) => (
          <li
            css={[
              tw`list-disc list-outside ml-5 py-1 font-semibold leading-[180%]`,
            ]}
          >
            {children}
          </li>
        ),
        number: ({ children }) => (
          <li
            css={[
              tw`list-decimal list-outside ml-5 py-1 font-semibold leading-[180%]`,
            ]}
          >
            {children}
          </li>
        ),
      },

      block: {
        h1: ({ children }) => (
          <h1
            css={[
              tw`font-light tracking-[6px] leading-[110%] text-center text-5xl mb-6`,
            ]}
          >
            {children}
          </h1>
        ),
        h2: ({ children }) => (
          <h2 css={[tw`text-3xl font-semibold mb-5`]}>{children}</h2>
        ),
        h3: ({ children }) => (
          <h3
            css={[tw`font-light tracking-[6px] leading-[110%] text-2xl mb-4`]}
          >
            {children}
          </h3>
        ),
        h4: ({ children }) => (
          <h4
            css={[
              tw`font-light tracking-[4px] leading-[110%] text-center text-xl mb-3`,
            ]}
          >
            {children}
          </h4>
        ),
        normal: ({ children }) => (
          <p css={[tw`font-book leading-[140%] mb-3 last:mb-0`]}>{children}</p>
        ),
      },
      marks: {
        disclaimer: ({ children }) => (
          <>
            {parseDisclaimerBlocks(children, selection =>
              dispatch(toggleDisclaimersModal(selection)),
            )}
          </>
        ),
        link: ({ children, value }) => (
          <a
            css={tw`text-toyotaRed !p-0 underline`}
            target="_blank"
            href={value?.href}
          >
            {children}
          </a>
        ),
        internalLink: ({ children, value }) => (
          <Link
            css={tw`text-toyotaRed !p-0 underline`}
            to={`/${value?.internal?.slug?.current}/`}
          >
            {children}
          </Link>
        ),
        strong: ({ children }) => (
          <strong css={tw`font-bold`}>{children}</strong>
        ),
        alignCenter: ({ children }) => (
          <div css={tw`content-center`}>{children}</div>
        ),
        alignRight: ({ children }) => (
          <div css={tw`content-end`}>{children}</div>
        ),
      },
    }
  }, [])
  return (
    <PortableText
      value={portableTextEditor}
      components={portableTextComponents}
    />
  )
}
export default FeaturedSnippetPortableText
